<template>
    <div>
        <CRow class="mb-3 ml-2">
            <h3>엑셀 업로드</h3>
        </CRow>
        <CRow>
            <CCol sm="12">
                <CTableWrapper
                        :items="getShuffledUsersData()"
                        hover
                        striped
                        bordered
                        small
                        fixed
                        caption="Combined All Table"
                />
            </CCol>
        </CRow>
        <CRow style="margin-left: 1%; margin-top: 1%;">
            <span>
                <label>등록 방식 : 부분 등록</label>
            </span>
        </CRow>
        <CRow style="margin-left: 3%; margin-bottom: 3%;">
            <label>
                - 기존 환자 정보는 그대로 유지하고 입력한 환자 정보만 등록(또는 갱신)합니다.<br>
                - 청구액이 있는 경우 금액을 추가로 청구합니다.
            </label>
        </CRow>
        <CRow style="margin-left: 2%; margin-bottom: 1%;">
            <div role="group" class="form-check">
                <input type="checkbox" class="form-check-input" value="알림메시지 전송">
                <label style="font-size: medium;">청구내역이 있을 경우 알림메시지로 전송합니다.</label>
            </div>
        </CRow>
        <CRow>
            <CCol class="btn-col-margin" sm="1">
                <button label=""
                        type="button"
                        class="btn btn-info btn-block"
                        @click="$router.push({name: 'paymanageinsert'})">
                    등 록
                </button>
            </CCol>
        </CRow>
    </div>
</template>
<style>
    .btn-col-margin {
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
</style>
<script>
    /*import CTableWrapper from './Table.vue'*/
    import CTableWrapper from "../base/PayManagementTable";
    import usersData from '../users/UsersData'

    export default {
        name: 'Tables',
        components: {CTableWrapper},
        methods: {
            shuffleArray(array) {
                for (let i = array.length - 1; i > 0; i--) {
                    let j = Math.floor(Math.random() * (i + 1))
                    let temp = array[i]
                    array[i] = array[j]
                    array[j] = temp
                }
                return array
            },

            getShuffledUsersData() {
                return this.shuffleArray(usersData.slice(0))
            },
        }
    }
</script>
